import React from 'react';
import {usePerson} from 'src/redux/selectors/usePerson';
import type {IFormFieldV2} from 'src/types/FormV2';
import {FormViewRowV2} from '../FormViewRow/FormViewRowV2';

export interface FormViewPersonSelectorV2Props {
  field: IFormFieldV2;
  value: string | number | undefined;
}

export const FormViewPersonSelectorV2: React.FC<
  FormViewPersonSelectorV2Props
> = ({field, value}) => {
  const person = usePerson({value: Number(value)});

  return <FormViewRowV2 field={field} value={person.subject} />;
};
